import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import i18n from "./i18n";
import { localizedPath } from "./utiles/localizedPath"; // Import localizedPaths
import "@/assets/style.css"; // Import global styles

const app = createApp(App);

app.use(router);
app.use(i18n);

app.config.globalProperties.$localizedPath = localizedPath;

app.mount("#app");
